import { InputField } from '@whistler-ui/k2/components/InputField';
import { isFieldError } from '@whistler-ui/k2/helpers/formik';
import { FormikErrors, FormikTouched } from 'formik';
import { ChangeEvent, ChangeEventHandler, FocusEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

type DefaultFieldProps = {
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void;
  handleBlur: FocusEventHandler<HTMLInputElement>;
  values: Record<string, any>;
  isRequired?: boolean;
  errors: FormikErrors<any>;
  onChangeRegex?: RegExp;
  handleChangeOnInput?: (
    e: ChangeEvent<HTMLInputElement>,
    setFieldValue: (field: string, value: any) => void,
    onChangeRegex: RegExp,
  ) => void;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  touched: FormikTouched<any>;
  fieldProps?: any;
  fieldName: string;
  name: string;
};

export const DefaultField = ({
  setFieldValue,
  handleBlur,
  values,
  isRequired,
  errors,
  onChangeRegex,
  handleChangeOnInput,
  handleChange,
  touched,
  fieldProps,
  fieldName,
  name,
}: DefaultFieldProps) => {
  const { t } = useTranslation();

  const value = values[fieldName] || '';

  return (
    <div className="max-w-[320px] w-full" key={fieldName}>
      <InputField
        label={t(`componentTestDataPane_${name}_label`)}
        required={isRequired}
        aria-required={isRequired}
        error={isFieldError(fieldName as string, touched, errors)}
        errorMessage={
          errors[fieldName] ? t(String(errors[fieldName])) : undefined
        }
        data-cy={`test-data-input-${fieldName}`}
        name={fieldName}
        id={fieldName}
        onBlur={handleBlur}
        onChange={e =>
          handleChangeOnInput
            ? handleChangeOnInput(e, setFieldValue, onChangeRegex!)
            : handleChange(e)
        }
        placeholder={t(`componentTestDataPane_${name}_placeholder`)}
        touched={Boolean(touched[fieldName]).toString()}
        type="text"
        value={value}
        {...fieldProps}
      />
    </div>
  );
};
